import { SET_AVAILABILITY } from '@/constants/store-types'

const defaultLocation = {
  latitude: null,
  longitude: null,
  speed: null,
  accuracy: null,
  bearing: null,
  night: false,
  weather: null
}

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        $title() {
          let metaTitle = this.$route.meta.title
          if (metaTitle && metaTitle.match(/{(.*?)}$/g)) {
            const params = metaTitle.match(/{(.*?)}/g)

            params.forEach((param) => {
              const paramName = param.replace('{', '').replace('}', '')
              metaTitle = metaTitle.replace(
                param,
                `.${this.$route.params[paramName]}`
              )
            })
          }

          const title =
            metaTitle && this.$te(metaTitle)
              ? this.$t(metaTitle)
              : this.$t('branding.appTagline')

          return title
        },
        $available: {
          get() {
            return this.$store.state.available
          },
          set(value) {
            this.$store.commit(SET_AVAILABILITY, value)
          }
        },
        $webView() {
          return this.$store.getters.webView
        }
      },
      watch: {
        $available(value) {
          if (this.$webView) {
            if (value) {
              // eslint-disable-next-line no-undef
              app.startService(15000, 5)
            } else {
              // eslint-disable-next-line no-undef
              app.endService()
            }
          }
        }
      },
      methods: {
        $isObject(val) {
          return val !== null && typeof val === 'object' && !Array.isArray(val)
        },
        $isEmpty(value) {
          return typeof value === 'object' && value
            ? !Object.keys(value).length
            : value == null || value.length === 0
        },
        $getQueryFilter(q, remove = false) {
          let found = false
          let query = Object.assign({}, this.$route.query)
          let result = null

          if (Object.keys(query).length) {
            if (query[q]) {
              result = query[q]
              delete query[q]
              found = true
            }

            if (remove && found) this.$router.replace({ query })
          }

          return result
        },
        $getCurrentLocation(timeout = 5000) {
          return new Promise((resolve) => {
            if (this.$webView) {
              // eslint-disable-next-line no-undef
              const currentLocation = app.getCurrentLocation()

              if (currentLocation) {
                const currentLocationObject = JSON.parse(currentLocation)
                return resolve({
                  ...defaultLocation,
                  ...currentLocationObject
                })
              } else {
                return resolve(defaultLocation)
              }
            } else {
              if ('navigator' in window && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  (position) => {
                    return resolve({
                      ...defaultLocation,
                      latitude: position.coords.latitude,
                      longitude: position.coords.longitude,
                      speed: position.coords.speed,
                      accuracy: position.coords.accuracy,
                      bearing: position.coords.heading
                    })
                  },
                  () => {
                    return resolve(defaultLocation)
                  },
                  { timeout }
                )
              } else {
                return resolve(defaultLocation)
              }
            }
          })
        },
        $webViewUpdateCurrentOrder() {
          if (this.$webView) {
            // eslint-disable-next-line no-undef
            app.updateCurrentOrder()
          }
        }
      }
    })
  }
}
